import React, { memo } from 'react';
import { CloseIcon } from '../../icons';
import { ListItem } from '../list-item';
import { ListDivider } from '../list-divider';
/**
 * @private
 */
export const ClearAllButton = /*#__PURE__*/memo(function ClearAllButton(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem, {
    iconLeft: /*#__PURE__*/React.createElement(CloseIcon, null),
    selectable: false,
    ...props
  }), /*#__PURE__*/React.createElement(ListDivider, null));
});